import { persistedStore } from 'lib/util';

export interface AuthStore {
  token?: string;
  setToken: (token: string) => void;
  clearToken: () => void;
}

export const useAuthStore = persistedStore<AuthStore>('AUTH', (set, get) => ({
  setToken: (token: string) => {
    set({ token });
  },
  clearToken: () => {
    set({ token: undefined });
  }
}));
